import * as actionTypes from '../actionTypes';

export default function isUpdating(state, action) {
  switch (action.type) {
    case actionTypes.UPDATE_CONFIG:
    case actionTypes.TOGGLE_OPTION:
    case actionTypes.START_OVER:
      return true;
    case actionTypes.UPDATE_CONFIG_SUCCESS:
    case actionTypes.UPDATE_CONFIG_ERROR:
    case actionTypes.TOGGLE_OPTION_SUCCESS:
    case actionTypes.TOGGLE_OPTION_ERROR:
    case actionTypes.TOGGLE_OPTION_CONFLICT_RESOLVE:
    case actionTypes.TOGGLE_OPTION_CONFLICT_CANCEL:
    case actionTypes.START_OVER_SUCCESS:
      return false;
    default:
      return state || false;
  }
}
